/**
 * @param {Object[]} options
 * @param {string} filter
 * @returns {Object[]}
 */
export const defaultFilterCallback = (options, filter) => filter === '' ? options : options.filter(_ref => {
  let {
    label
  } = _ref;
  return label.match(new RegExp(filter, 'i'));
});